import { host_haiji_url } from '@/api/host'
var abnormalApi = {
  /**
   * 异常列表
   */
  addRemark: `${host_haiji_url}/v1/admin/abnormal/process/`, //客服处理异常  http://projectdoc.epetbar.com/index.php?s=/177&page_id=4000
  getUnActiveList: `${host_haiji_url}/v1/admin/abnormal/unactivated`, //异常列表（未激活被查询） http://projectdoc.epetbar.com/index.php?s=/177&page_id=3980
  getLimitList: `${host_haiji_url}/v1/admin/abnormal/toplimit`, //异常列表（一天查询防伪码达到上限） http://projectdoc.epetbar.com/index.php?s=/177&page_id=3981
}

export { abnormalApi }
